const BASE_URL = 'https://docs.copado.com/articles/copado-robotic-testing-publication';

export const HELP_DOCS_URL = {
  AUTOMATED_TEST_DESIGN: BASE_URL + '/automatedtestdesign',
  BETA_FEATURES: BASE_URL + '/betafeatures',
  COMMAND_LINE_PARAMS: BASE_URL + '/commandline',
  CONSUMER_KEY_SECRETS: BASE_URL + '/get-the-consumer-key-and-consumer-secret',
  CURRENT: BASE_URL + '/current',
  FLOW_EDITOR: BASE_URL + '/flow-editor',
  FLOW_EDITOR_BLOCKS: BASE_URL + '/flow-editor/a/_my_blocks',
  MAIN: BASE_URL,
  MOBILE_CONFIGURATION: BASE_URL + '/configuration',
  PAT_AZURE: BASE_URL + '/azure',
  PAT_BITBUCKET: BASE_URL + '/bitbucket',
  PAT_COPADO_CICD: BASE_URL + '/copado-cicd',
  PAT_COPADO_VERSION_CONTROL: BASE_URL + '/copado-version-control',
  PAT_GIT_HTTPS: BASE_URL + '/git-https',
  PAT_GITHUB: BASE_URL + '/github',
  PAT_GITLAB: BASE_URL + '/gitlab',
  PAT_JIRA: BASE_URL + '/copado-robotic-testing-jira-integration',
  PAT_LOCATION_MOVED: BASE_URL + '/version-2-15-0/a/h2_227575199',
  PROJECT_CREATE: BASE_URL + '/createproject',
  QEDITOR: BASE_URL + '/qeditor',
  QUICK_START: BASE_URL + '/quickstart',
  ROBOTS: BASE_URL + '/robots',
  SUITE_ADD: BASE_URL + '/suitesadding',
  SUITE_BROWSING: BASE_URL + '/suitesbrowsing',
  SUITES: BASE_URL + '/suites',
  TEST_DATA: BASE_URL + '/test-data-feature',
  WHATS_NEW: BASE_URL + '/new',
} as const;
